import React from 'react';

import { ReactComponent as AddIcon } from '@assets/svg/add.svg';

import Button from '@components/uikit/Button/Button';
import FilterSearch from '@components/uikit/FilterSearch/FilterSearch';
import Tabs from '@components/uikit/Tabs/Tabs';

import { MODAL_NAMES } from '@constants/modalRenderers';

import useTranslation from '@hooks/useTranslation';

import { useModalActions } from '@store/useModalStore';

import {
  selectFilterAssetStatus,
  selectSearchValue,
  useAssetTrackerActions,
} from '../../store/useAssetTrackerStore';
import style from './style.module.scss';

const FilterPanel = () => {
  const { t } = useTranslation();

  const { setActiveModal } = useModalActions();
  const { setSearchValue, setFilterAssetStatus, setClearActiveAsset } = useAssetTrackerActions();

  const searchValue = selectSearchValue();
  const filterAssetStatus = selectFilterAssetStatus();

  const toggleAssetStatuses = [
    { value: 'all', label: t('All') },
    { value: 'active', label: t('Active') },
    { value: 'inactive', label: t('Inactive') },
  ];

  const handleTabsChange = (value: any) => {
    setFilterAssetStatus(value);
    setClearActiveAsset();
  };

  const handleChangeSearchValue = (value: string) => {
    setSearchValue(value);
    setClearActiveAsset();
  };

  return (
    <div className={style.filterPanel}>
      <div className={style.filter}>
        <Tabs
          value={filterAssetStatus}
          tabsItems={toggleAssetStatuses}
          label={t('Asset Status')}
          type={'woHelperText'}
          onChange={handleTabsChange}
          variant={'horizontal'}
        />
        <Button
          text={t('Add Asset Tracking')}
          onClick={() => setActiveModal({ name: MODAL_NAMES.createEditAssetTrackingModal })}
          type="secondary"
          leftElement={<AddIcon className={style.addIcon} />}
        />
      </div>
      <div className={style.searchBlock}>
        <FilterSearch
          value={searchValue}
          onChange={handleChangeSearchValue}
          variant={'header-search'}
          placeholder={t('Search assets...')}
        />
      </div>
    </div>
  );
};

export default FilterPanel;
